<template lang="pug">
  LayoutLearningCenter.PageLearningCenterSingle(
    :data="learnPostData"
  )
    LearningCenterSingle(:data="learnPostData")
</template>

<script>
import { mapState } from 'vuex';
import pageMixin from 'Mixins/pageMixin';
import modalDocumentDownloadByHashMixin from 'Mixins/modalDocumentDownloadByHashMixin';
import scrollByHashMixin from 'Mixins/scrollByHashMixin';
import LayoutLearningCenter from './LayoutLearningCenter';
import LearningCenterSingle from './components/LearningCenterSingle';

export default {
  name: 'PageLearningCenterSingle',
  components: {
    LayoutLearningCenter,
    LearningCenterSingle,
  },
  mixins: [pageMixin, scrollByHashMixin, modalDocumentDownloadByHashMixin],
  computed: {
    ...mapState('learningCenter', [
      'learnPostData',
    ]),
    pageTitle() {
      return this.learnPostData.seo_title || this.learnPostData.title;
    },
    pageDescription() {
      return this.learnPostData.seo_description;
    },
    pageImage() {
      return this.learnPostData.imageUrl;
    },
    pageUrl() {
      return this.learnPostData?.canonical;
    },
    articleSection() {
      const items = [];
      if (this.learnPostData.tags) {
        this.learnPostData.tags.forEach((item) => {
          const { name } = item;
          items.push(name);
        });
        return items.concat(this.learnPostData.category.name).join(', ');
      }
      return this.learnPostData.category;
    },
  },
  staticData: {
    $_scrollByHash_offsetAdditional: -52,
  },
};
</script>

<style lang="sass" scoped>
</style>
